import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";

interface CellComponentProps {
    featureValues: Record<string, Record<string, string>>;
    featureName: string;
    sectionName: string;
}

const CellComponent = ({
    featureValues,
    featureName,
    sectionName
}: CellComponentProps) => (
    <Col
        xs={12}
        className={cn(
            "tw:border-t tw:border-r tw:border-grey-light tw:px-4 tw:flex-[17.5rem] tw:w-70 tw:max-w-70",
            "tw:[@media(max-width:768px),(max-height:799px)]:flex-[12.5rem] tw:[@media(max-width:768px),(max-height:799px)]:w-50 tw:[@media(max-width:768px),(max-height:799px)]:max-w-50"
        )}
    >
        <Row>
            <Col xs={12}>
                <div className={cn("tw:pt-5 tw:pb-2", "tw:md:py-2")}>
                    {!featureValues[sectionName]?.[featureName] && (
                        <span
                            className={cn(
                                "tw:w-full tw:inline-block tw:whitespace-normal"
                            )}
                        >
                            &nbsp;
                        </span>
                    )}
                    {featureValues[sectionName]?.[featureName] === "true" && (
                        <span
                            className={cn(
                                "tw:w-full tw:inline-block tw:whitespace-normal"
                            )}
                        >
                            <i className={cn("las la-check")} />
                        </span>
                    )}
                    {featureValues[sectionName]?.[featureName] === "false" && (
                        <span
                            className={cn(
                                "tw:w-full tw:inline-block tw:whitespace-normal"
                            )}
                        >
                            <i className={cn("las la-times")} />
                        </span>
                    )}
                    {featureValues[sectionName]?.[featureName] &&
                        !["true", "false"].includes(
                            featureValues[sectionName]?.[featureName]
                        ) && (
                            <span
                                className={cn(
                                    "tw:w-full tw:inline-block tw:whitespace-normal"
                                )}
                            >
                                {featureValues[sectionName]?.[featureName]}
                            </span>
                        )}
                </div>
            </Col>
        </Row>
    </Col>
);

export { CellComponent };
